var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.41675C5.81186 2.41675 2.41669 5.81192 2.41669 10.0001C2.41669 14.1882 5.81186 17.5834 10 17.5834C14.1882 17.5834 17.5834 14.1882 17.5834 10.0001C17.5834 5.81192 14.1882 2.41675 10 2.41675ZM0.916687 10.0001C0.916687 4.9835 4.98343 0.916748 10 0.916748C15.0166 0.916748 19.0834 4.9835 19.0834 10.0001C19.0834 15.0167 15.0166 19.0834 10 19.0834C4.98343 19.0834 0.916687 15.0167 0.916687 10.0001ZM10 8.41675C10.4142 8.41675 10.75 8.75253 10.75 9.16675V13.3334C10.75 13.7476 10.4142 14.0834 10 14.0834C9.58581 14.0834 9.25002 13.7476 9.25002 13.3334V9.16675C9.25002 8.75253 9.58581 8.41675 10 8.41675ZM10 7.50008C10.4603 7.50008 10.8334 7.12699 10.8334 6.66675C10.8334 6.20651 10.4603 5.83342 10 5.83342C9.53978 5.83342 9.16669 6.20651 9.16669 6.66675C9.16669 7.12699 9.53978 7.50008 10 7.50008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.214a019b687f21f0eb6ea51cbc27bafa.svg";
export { ForwardRef as ReactComponent };